/************************* Preact Files ************************/
import { h, Component } from 'preact';
import { connect } from 'preact-redux';

/************************* Custom Component Files ************************/
import { fetchProjectProgramAreas, fetchProjectDetailsOnSelection } from '../../../src/shared/actions/projectDetailActions';
import DonutBarChart from './donutBarChart';
/************************* Third Party  Files ************************/
import Helmet from 'preact-helmet';

/************************* Style Files ************************/
import style from '../projectDescription/style.scss';
import PreLoader from '../../components/preLoader';

class ProjectDonut extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount = () => {

		this.props.fetchProjectProgramAreas(this.props.projectId, this.props.year)
	}

	handleOnClick = (e) => {
		if (e.size && e.size != 1) { }
	}
	onTargetClick = (e) => {

		if (e.name) {
			let targetIds = e.name.replace('Target', '').trim().split('.');
			window.location = '/programme-area/targets/' + targetIds[0] + '/' + targetIds[1];
		}
	}
	onSDGClick = (e) => {
		return
		if (e.parent.name.includes('PA')) {
			window.location = '/programme-area/' + e.parent.code + '/' + e.parent.fullName;
		}
	}

	piechartData(resp) {
		resp.sdg.map(obj => {
			obj.fullName = obj.name;
			obj.name = 'Programme Area ' + obj.code;
			obj.image = '/static/assets/icons/sdg/PA-' + obj.code + '.svg';
		});
		let tempData = { name: '', size: 1 };
		tempData.children = resp.sdg;
		resp = tempData;
		return resp
	}



	render(props) {
		return (
			<div style={{ margin: 'auto', maxWidth: '1200px' }}>
				<div style={{ borderBottom: '1px solid rgb(204, 204, 204)', marginBottom: '70px' }}>
					<span style={{ margin: '0' }} class={style.theme_slider_title}>Programme Areas</span>
					{this.props.projectDetail && this.props.projectDetail.programAreaBudget && this.props.projectDetail.programAreaBudget.data && this.props.projectDetail.programAreaBudget.data ?
						<DonutBarChart
							donutData={this.props.projectDetail.programAreaBudget}
							donutChartId={'budget_area'}
							barChartData={this.props.projectDetail.programAreaBudget}
							sdg={'true'}
							recipientProfile={'true'}
						/>
						: <div style={{ position: 'relative', height: 344 }}>
							<PreLoader />
						</div>}
				</div>
				<div>
					<span style={{ marginLeft: '0' }} class={style.theme_slider_title}>SDG</span>
					<DonutBarChart
						donutData={this.props.projectDetail.projectSDGBudget}
						donutChartId={'project_sdg_budget_area'}
						barChartData={this.props.projectDetail.projectSDGBudget}
						sdg={'true'}
						recipientProfile={'true'}
						sdgIndex={this.props.sdgIndex}
					/>
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	const { projectDetailMapData } = state.mapData;
	const mapCountryData = state.mapData;
	const sdg = state.sdgData;
	return {
		projectDetail: state.projectDetail,
		projectDetailMapData,
		mapCountryData,
		sdgIndex: sdg.data
	};
};

const mapDispatch = (dispatch) => ({
	fetchProjectProgramAreas: (id, year) => dispatch(fetchProjectProgramAreas(id, year)),
	fetchProjectDetailsOnSelection: (id) => dispatch(fetchProjectDetailsOnSelection(id))
})

export default connect(mapStateToProps, mapDispatch)(ProjectDonut);



// WEBPACK FOOTER //
// ./components/projectDonutBarChart/index.js